import React from 'react';

const TONE_CLASSES = {
  light: {
    border: 'border-slate-200',
    active: 'border-themePrimary text-themePrimary',
    inactive: 'border-transparent text-slate-500 hover:text-slate-700',
  },
  dark: {
    border: 'border-slate-800',
    active: 'border-violet-500 text-violet-400',
    inactive: 'border-transparent text-slate-500 hover:text-slate-300',
  },
};

// Single underline-tab convention — replaces 3 independently-drifted
// implementations (different active colors, one missing the transparent
// baseline border which caused a layout shift on tab switch).
const Tabs = ({ tabs, active, onChange, tone = 'light', className = '' }) => {
  const t = TONE_CLASSES[tone];
  return (
    <div className={['flex gap-6 border-b', t.border, className].join(' ')}>
      {tabs.map((tab) => {
        const Icon = tab.icon;
        const isActive = tab.key === active;
        return (
          <button
            key={tab.key}
            type="button"
            onClick={() => onChange(tab.key)}
            className={[
              'flex items-center gap-1.5 pb-3 text-sm font-medium border-b-2 transition-colors',
              isActive ? t.active : t.inactive,
            ].join(' ')}
          >
            {Icon && <Icon className="w-4 h-4" />}
            {tab.label}
            {tab.count !== undefined && (
              <span className="text-xs text-slate-400">({tab.count})</span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default Tabs;
